var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconDiscussionLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconDiscussion",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M677.647 16v338.936h112.941V129.054h1016.47V919.53h-225.994v259.765L1321.412 919.53h-79.172V467.878H0v1016.47h338.71v418.9l417.996-418.9h485.534v-451.877h32.753l419.125 419.124v-419.124H1920V16H677.647ZM338.79 919.563h564.706v-112.94H338.79v112.94Zm0 225.883h338.936v-113.054H338.79v113.054Zm-225.85-564.74h1016.47v790.701H710.4L451.652 1631.06v-259.652h-338.71V580.706Z",
      fillRule: "evenodd"
    })));
  }
}
IconDiscussionLine.glyphName = 'discussion';
IconDiscussionLine.variant = 'Line';
IconDiscussionLine.displayName = 'IconDiscussionLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconDiscussionLine.propTypes = {
  ...SVGIcon.propTypes
};
IconDiscussionLine.allowedProps = [...SVGIcon.allowedProps];
export default IconDiscussionLine;
export { IconDiscussionLine };